/**
 * Free text in a table cell (SA-447): at most two lines, the full text on
 * hover through a native `title` (the register already uses `title` for the
 * status source), and in full on the record. The clamp sits on this inner
 * span, never on the <td>: display -webkit-box on a table cell breaks table
 * layout. The cell gives it a minimum width so it never wraps into a strip.
 */
export function ClampedText({ text }: { text: string }) {
  return <span className="line-clamp-2 break-words" title={text}>{text}</span>
}
